<template>
    <div class="wishlist-modal-controller">
      <LoginForm
        class="m-t-12"
        v-if="!isLoggedIn"
        @on-logged-in="onLoggedIn()"
        :backgroundColor="Globals.colors.white"
      />
      <div v-else>
        <SelectSizeModule
          v-if="!isMoveFromShoppingBag"
          ref="sizeModule"
          class="m-t-12 m-b-12"
          :modelValue="sizeSelectorOverlay"
          :modal="false"
          :model="model"
          :currentVariant="currentVariant"
          :sizes="sizes"
          :hideCloseBtn="true"
          :theme="sizeTheme"
          @updatedSelectedVariant="updateSelectedVariant"
          @ready="getSelectedSize"
          aria-label="Select size"
        />
        <hr v-if="sizeSelectorOverlay === 'wishlist' && !isMoveFromShoppingBag" />
        <section
          v-if="
            !wishlistLoader && wishlistsFiltered && wishlistsFiltered.length > 0
          "
          :class="{ '-disabled': !size && !isMoveFromShoppingBag }"
        >
          <div class="m-t-18 m-b-18">
            <button
              id="CreateNewWishList"
              class="d-flex align-items-center -stripped"
              role="button"
              aria-expanded="false"
              :class="{ '-clickable -blue -underline-hover': size || isMoveFromShoppingBag }"
              @click="createNewWishListToggle()"
            >
              <span>Create new list</span>
              <SvgComponent
                class="m-l-3"
                :icon="{
                  name: 'Plus',
                  size: 12,
                  color: size
                    ? Globals.colors.blueDark
                    : Globals.colors.grayLight,
                }"
              />
            </button>
            <div v-if="addListToggle">
              <div class="d-flex align-items-end m-t-18">
                <InputFieldV2
                  id="AddWishlist"
                  :disabled="saving"
                  v-model="newWishlistName"
                  :ariaLabel="'Wishlist name'"
                />
                <ButtonComponent
                  class="m-l-18"
                  theme="main"
                  :block="false"
                  :overrideThemeColor="Globals.colors.blueDark"
                  :loading="savingList"
                  :disabled="savingList"
                  :text="'Add'"
                  @click="saveToNewList()"
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="m-b-18">
            <div>Add/remove from list</div>
            <ul>
              <li v-for="(item, wIndex) in wishlistsFiltered"  :key="`${item.Name}-${wIndex}`">
            <CheckBox
              v-model="selectedWishlists[wIndex]"
              :id="`${item.Name}-${wIndex}`"
              :disabled="!size && !isMoveFromShoppingBag"
              :small="true"
              class="m-t-12"
              :label="item.Name"
              @change="changesMade = true"
            />
              </li>
            </ul>
          </div>
          <div
            style="
              position: sticky;
              bottom: 0;
              z-index: 10;
              width: 100%;
              background-color: #fcfcfc;
            "
            class="p-b-18"
          >
            <hr />
            <div class="grid-2 m-t-18">
            <ButtonComponent
              class="g-1"
              theme="cta"
              :block="true"
              :overrideThemeColor="
               overrideThemeColor
              "
              :loading="saving"
              :text="'Save'"
              @click="save()"
            />
             <ButtonComponent
              class="g-1"
              theme="main"
              :ghost="true"
              :block="true"
              :text="'Cancel'"
              @click="$emit('on-cancel')" />
            </div>
          </div>
        </section>
        <div v-else class="-p-relative" style="min-height: 100px">
          <SvgComponent
            class="sizeselector-save"
            :icon="{
              name: 'Loading',
              color: Globals.colors.grayDark,
              size: 14,
            }"
          />
        </div>
      </div>
      <a class="-clickable -blue m-b-18" :href="getLink('WishlistPage')">{{
        insertString("Global", "GotoWishlistPage")
      }}</a>
    </div>

</template>
<script>
import { mapState } from 'vuex';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import { WISHLIST_TYPES } from '@/Scripts/constants.js';
// import { ProductConvertToOldModel } from '@/Scripts/lib/helper/productHelper.js';
import { TrackerProductObject, TrackerWishlistAdd } from '@/Scripts/lib/helper/trackingHelper.js';
import wishlistHelper from '@/Scripts/lib/helper/wishlistHelper';
import CheckBox from '@/Scripts/components/shared/CheckBox/CheckBox.vue';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
import InputFieldV2 from '@/Scripts/components/shared/InputFieldV2/InputFieldV2.vue';
import toastMixin from '@/Scripts/lib/mixins/toastMixin.js';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';

// const ProductCardBagSmall = () => import('@/Scripts/components/productcards/ProductCardDeprecated/ProductCardBagSmall.vue');
const SelectSizeModule = () => import('@/Scripts/components/productcards/ProductCard/Assets/SelectSizeModule.vue');
const LoginForm = () => import('@/Scripts/components/form/LoginForm/LoginForm.vue');

export default {
  mixins: [siteInfo, toastMixin],
  components: {
    CheckBox,
    ButtonComponent,
    InputFieldV2,
    SvgComponent,
    // ProductCardBagSmall,
    SelectSizeModule,
    LoginForm
  },
  props: {
    model: Object,
    currentVariant: Object,
    sizes: Array,
    startSizeIndex: Number,
    outlet: Boolean,
    sizeTheme: String,
    isMoveFromShoppingBag: Boolean
  },
  data () {
    return {
      selectedWishlists: [],
      addableToList: [],
      removableFromList: [],
      sizeIndex: -1,
      newWishlistName: '',
      addListToggle: false,
      saving: false,
      savingList: false,
      sizeSelectorOverlay: 'wishlist',
      changesMade: false
    };
  },
  watch: {
    email: {
      immediate: true,
      handler () {
        if (this.show && !this.wishlistIsLoaded && this.email) {
          this.$store.dispatch('bag/getWishlist', this.email);
        }
      }
    },
    size (val) {
      if (val) {
        this.checkIfOnWishlist();
      }
    },
    wishlistIsLoaded (val) {
      if (val) {
        this.checkIfOnWishlist();
      }
    },
    model: {
      immediate: true,
      handler () {
        if (this.isMoveFromShoppingBag) {
          this.checkIfOnWishlist();
        }
      }
    }
  },
  computed: {
    ...mapState({
      wishlists: state => state.bag.wishlists,
      wishlistItems: state => state.bag.wishlistItems,
      wishlistLoader: state => state.bag.wishlistLoader,
      user: state => state.userInformation,
      isLoggedIn: state => state.appContext.isLoggedIn
    }),
    wishlistsFiltered () {
      return this.wishlists.filter(l => l.WishlistType === WISHLIST_TYPES.DEFAULT || l.WishlistType === WISHLIST_TYPES.CX || l.WishlistType === WISHLIST_TYPES.STORE);
    },

    wishlistIsLoaded () {
      return this.wishlistsFiltered && this.wishlistsFiltered.length > 0 && !this.wishlistLoader;
    },
    email () {
      if (this.isLoggedIn) {
        return document.body.getAttribute('data-identify');
      }
      return this.user.userInformation.Email;
    },
    size () {
      if (!this.sizes || this.sizeIndex === -1) {
        return '';
      }
      return this.sizes[this.sizeIndex].Size;
    },
    // cardItem () {
    //   if (!this.model || !this.currentVariant) {
    //     return null;
    //   }
    //   return ProductConvertToOldModel(this.model, this.currentVariant);
    // },
    trackerItem () {
      if (!this.model || !this.currentVariant) {
        return null;
      }
      return TrackerProductObject({
        product: this.model,
        colorVariant: this.currentVariant,
        size: this.size,
        outlet: this.outlet,
        pageType: this.$root._vnode.tag.replace(/vue-component-\d*-/, '').trim()
      });
    },
    wishlistItem () {
      if (this.isMoveFromShoppingBag) {
        return {
          sku: this.currentVariant.Code,
          code: this.model.Code,
          colorCode: this.currentVariant.ColorCode,
          colorName: this.currentVariant.ColorName,
          sizeIndex: this.sizeIndex,
          size: this.size
        };
      }
      if (this.sizeIndex === -1) {
        return null;
      }
      return {
        sku: this.sizes[this.sizeIndex].Sku || this.currentVariant.Code,
        code: this.model.Code,
        colorCode: this.currentVariant.ColorCode,
        colorName: this.currentVariant.ColorName,
        sizeIndex: this.sizeIndex,
        size: this.size
      };
    },
    overrideThemeColor () {
      return !this.changesMade ? this.Globals.colors.grayLight : null;
    }
  },

  methods: {
    changes (value) {
      this.changesMade = value;
    },
    createNewWishListToggle () {
      this.addListToggle = !this.addListToggle;
      // if (this.addListToggle) set aria-expanded to true
      if (this.addListToggle) {
        this.$nextTick(() => {
          document.getElementById('CreateNewWishList').setAttribute('aria-expanded', 'true');
          document.getElementById('AddWishlist').focus();
        });
      }
    },
    getSelectedSize () {
      if (this.sizeIndex > -1) {
        this.$refs.sizeModule.updatedSelectedVariant(this.sizeIndex);
      }
    },
    onLoggedIn () {
      this.$store.dispatch('userInformation/getUserInformation').then(() => {
        this.$nextTick(() => {
          this.$store.dispatch('appContext/setIsLoggedIn', true);
          this.$store.dispatch('appContext/setIsLoyalty', this.user.userInformation.Personas.Traits.IsLoyaltyMember);
        });
      });
    },
    checkIfOnWishlist () {
      const sku = this.wishlistItem.sku;
      if (sku) {
        this.wishlistsFiltered.forEach(async (list, index) => {
          let exist = false;
          list.Items.forEach(item => {
            if (`${item.Model} ${item.Color} ${item.Size}` === sku) {
              exist = true;
            }
          });
          this.$set(this.removableFromList, index, exist);
          this.$set(this.selectedWishlists, index, exist);
          this.$set(this.addableToList, index, !exist);
        });
      }
    },
    updateSelectedVariant (e) {
      this.sizeIndex = e;
      this.checkIfOnWishlist();
      eventBus.$emit('WISHLIST_SIZE_CHANGED', this.wishlistItem);
    },
    async saveToNewList () {
      // need to first create list then add
      this.savingList = true;
      const response = await wishlistHelper.addWishlist(this.newWishlistName);
      if (response) {
        this.$store.dispatch('bag/getWishlist', this.email);
        this.savingList = false;
        this.addListToggle = false;
        this.newWishlistName = '';
      }
    },
    save () {
      this.saving = true;
      this.selectedWishlists.forEach(async (checked, index) => {
        if (checked && this.addableToList[index]) {
          await this.addToWishlist(this.wishlistsFiltered[index]);
        } else if (!checked && this.removableFromList[index]) {
          await this.removeFromWishlist(this.wishlistsFiltered[index]);
        }
        console.log('saved to list: ', this.wishlistsFiltered[index].Name, 'with checked: ', checked);
      });
      setTimeout(() => {
        this.$emit('on-saved');
        this.saving = false;
        this.$store.dispatch('bag/getWishlist', this.email);
      }, 1000);
    },
    async addToWishlist (list) {
      try {
        const response = await wishlistHelper.addWishlistItem(list.Id, this.wishlistItem.sku);
        if (response) {
          TrackerWishlistAdd(this.trackerItem);
          this.addToast(list.Name, true);
          if (this.isMoveFromShoppingBag) {
            this.$store.dispatch('checkoutNew/removeCartItem', this.wishlistItem.sku);
          }
        }
      } catch (error) {
        console.log(error);
      };
    },
    async removeFromWishlist (list) {
      const listItem = list.Items.find(i => i.Model === this.wishlistItem.code && i.Color === this.wishlistItem.colorCode && i.Size === this.wishlistItem.size);
      if (listItem) {
        try {
          const response = await wishlistHelper.removeWishlistItem(list.Id, listItem.Id);
          if (response) {
            this.addToast(list.Name, false);
          }
        } catch (error) {
          console.log(error);
        };
      } else {
        console.log('could not find item: ', this.wishlistItem, 'in list: ', list);
      }
    },
    addToast (listName, add) {
      const name = `${this.model.Name} <br /> ${this.insertString('Global', 'Color')}: ${this.wishlistItem.colorName}<br />${this.insertString('Global', 'Size')}: ${this.size}`;
      const link = this.links.WishlistPage ? `<br /><a class="-clickable -underline" href="${this.links.WishlistPage}?returnurl=${window.location.href}">${this.insertString('Global', 'Bag', 'ViewWishlist')}</a>` : '';
      if (add) {
        this.$_toast_add(`${this.insertString('Global', 'Bag', 'AddedToWishlist')}: ${listName}`, `${name} ${link}`, 'success', 5000);
      } else {
        this.$_toast_add(`${this.insertString('Global', 'Bag', 'RemovedFromWishlist')}: ${listName}`, name, 'success', 3000);
      }
    }
  },
  created () {
    this.sizeIndex = this.startSizeIndex;
    if (!this.wishlistIsLoaded && this.email) {
      this.$store.dispatch('bag/getWishlist', this.email);
    }
  }
};
</script>
<style lang="scss">
.wishlist-modal-controller {
  ul, li {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
}
</style>
